class PreparationPageManager {
    private storageName = 'is-preparation-page-visited';

    constructor() {
        window.sessionStorage.removeItem(this.storageName);
    }

    public setVisited() {
        window.sessionStorage.setItem(this.storageName, '1');
    }

    public get isVisited() {
        return window.sessionStorage.getItem(this.storageName) === '1';
    }
}

/**
 * Объект для работы с фактом посещения страницы подготовки
 *
 * Объект необходим из-за особенностей работы Safari
 * */
export const preparationPageManager = new PreparationPageManager();
